<template>
    <div class="count-info">
        <span v-if="icon" :class="icon" class="count-info__icon"/>
        <div v-else class="count-info__authorization">{{ authorizationType }}</div>
        <span class="count-info__text" v-html="text"></span>
        <span class="count-info__amount">{{ amount }}</span>
        <slot name="tooltip"></slot>
    </div>
</template>

<script>
    export default {
        name: 'info-tag',
        props: {
            authorizationType: String,
            icon: String,
            text: String,
            amount: Number | String
        },
    }
</script>

<style lang="scss" scoped>
    .count-info {
        display: flex;
        position: relative;
        background-color: $bright_gray;
        padding: 3px 12px;
        height: 31px;
        border-radius: 5px;
        width: max-content;
        gap: 6px;
        align-items: center;
        font-size: 1.4rem;

        [class*="mobile"] & {
            padding: 5px 10px 5px 10px;
            font-size: 1.2rem;
        }

        &__authorization {
            background-color: $rust_orange;
            color: $white;
            font-size: 1.25rem;
            text-transform: uppercase;
            padding: 0 5px;
            height: 18px;
            line-height: 1.8rem;
        }

        &__icon {
            color: $rust_orange;
            font-size: 1.6rem;
        }
    }

</style>
